export const closeButtonWidth = 32;
export const closeButtonHeight = 32;
export const closeButtonMargin = 16;
export const closeButtonMarginLandscape = 19;

// two equal spaces of close button width around it
export const contentPaddingRight = closeButtonWidth * 2;
